import Vue from "vue";
import Vuex from "vuex";

import auth from "./auth.module";
import ui from "./ui.module";
import pageTransition from "./pagetransition.module";
import user from "./user.module";
import * as cart from './cart.module'

import { createToast } from "@/utils/helpers";

Vue.use(Vuex);

const state = {
  userObj: {}
};

const getters = {
  getUserObj: state => {
    return state.userObj;
  },
};


const mutations = {
  updateUser(state, user) {
    const { userObj: currentUser } = state;
    let newUser = { ...currentUser, ...user };
    state.userObj = newUser;
  },
  storeUser(state, user) {
    state.userObj = user;
  },
  tickUserObj(state) {
    state.userObj.tick = Math.random();
  },
  removeUser(state) {
    state.userObj = {};
  }
};

const actions = {
  toast(context, { title, message, autoHideDelay, appendToast, variant }) {
    createToast({ title, message, autoHideDelay, appendToast, variant });
  },
  tickUserObj({ commit }) {
    commit("tickUserObj");
  },
};

export default new Vuex.Store({
  modules: {
    auth,
    ui,
    pageTransition,
    user,
    cart

  },
  state,
  mutations,
  actions,
  getters
});
